<template>
    <div class="Field-Box">
        <div>
            <span class="title">{{title}} <span v-if="action">*</span></span>
            <span v-if="type === 'text'" :class="!text?'WidthVWEmpty':'WidthVW'">{{text?text:placeholder}}</span>
            <!--弹窗|| type === 'selectPeople'-->
            <div v-if="(type === 'popup' || type=== 'calendar' || type === 'manufacturer'||type==='dropdown') && !SelectionAndInput"
                :class="placeholder === showText ? 'popup' : 'action popup'" @click.stop="!Isdisabled?menuClick():''">
                {{showText}}
                <img src="../../assets/img/right-min.png" />
                <!--组件加叉号-->
                <i @click.stop="cancelValue" v-if="(type=== 'calendar'||type==='manufacturer')&&!action" class="cancelValue  van-icon van-icon-cross"></i>
            </div>
            <!--既需要弹窗也需要输入框-->
            <div v-if="type === 'manufacturer' && SelectionAndInput" :class="showText === '请输入' ? 'popup' : 'action popup'">
                <input @input="manuInputValue" placeholder='请输入' :value="showText==='请输入'?'':showText" type="text"  />
                <img src="../../assets/img/right-min.png" @click.stop="menuClick" />
            </div>

            <van-popup v-if="type === 'popup'" v-model="showDiaLog" position="bottom" :style="{ height: '50%', borderRadius: '10px 10px 0 0'}">
                <div class="picker-header">
                    <span @click="showDiaLog = false">取消</span>
                    <input type="text" placeholder="搜索" v-if="popupInput" @input="_popupInput" />
                    <span @click="confirm">确定</span>
                </div>
                <van-picker :columns="data" @cancel="showPicker = false" @change="onChange" item-height="15vw"
                    swipe-duration="500" :default-index="selectIndex" />
            </van-popup>
            <!--自定义下拉-->
            <van-action-sheet v-if="type==='dropdown'" v-model="showDiaLog" :round="true" :actions="data" @select="DropDown"
                cancel-text="取消" />
            <!--输入框-->
            <input v-if="type === 'input'" :maxlength="maxlength?maxlength:''" :type="inputType" :placeholder="placeholder"
                @input="input" :value="text" />
            <!--数字输入框-->
            <van-field input-align="right" :placeholder="placeholder" class="popup NumberClass" v-model="NumberInputValue"
                @input="NumberInput" v-if="type === 'number'" :type="name==='number'?'number':name==='tel'?'tel':'digit'" />
            <!--日历-->
            <van-calendar v-if="type === 'calendar'" :min-date="DateMin" :max-date="DateMax" v-model="showDiaLog"
                @confirm="onConfirm" />

            <!--tab-->
            <div class="tab" v-if="type === 'teb'">
                <div v-for="(item, index) in data" :tabSelectIndex="tabSelectIndex=tabSelected" :class="item.id == tabSelectIndex ? 'actionTab' : ''"
                    @click="tabChange(item, index)">{{item.name}}</div>
            </div>

            <!--自定义弹出框选择-->
            <van-popup v-if="type === 'manufacturer'" :name="name" v-model="showDiaLog" position="bottom" :style="{ height: '50%', borderRadius: '10px 10px 0 0'}">
                <div class="picker-header">
                    <span @click="manuCancel">取消</span>
                    <input type="text" v-model="InputValues" placeholder="输入" v-if="manupopupInput" @input="_manupopupInput" />
                    <span @click="manuconfirm">确定</span>
                </div>
                <van-picker :columns="manudata" @cancel="showPicker = false" @change="manuonChange" item-height="15vw"
                    swipe-duration="500" :default-index="manuselectIndex" />
            </van-popup>
        </div>
        <!--textarea-->
        <textarea v-if="type === 'textarea'" :placeholder="placeholder?placeholder:'请输入'" rows="4" cols="5" :value="text"
            @input="input" :disabled="Isdisabled" />
        </div>
</template>

<script>
    import { Field,Popup, Picker, Calendar,NumberKeyboard,ActionSheet  } from 'vant'
    export default {
        name: 'Field',
        props: {
            DateMin:{
                type:Date,
                default:()=>new Date(new Date().getFullYear()-5,0,1)
            },
            DateMax:{
                type:Date,
                default:()=>new Date()
            },
            type: {                         //  类型 input text teb popup calendar
                type: String | Array,
                default: 'input'
            },
            title: String,                  //  左侧高亮字体
            text: Number|String,          //  右侧字体
            action: {                       //  是否显示红标*
                type: Boolean,
                default: false
            },
            data: {                         //  列表数据
                type: Array | Object,
                default: null
            },
            inputType: {                    //  当type值为input时 设置input type
                type: String,
                default: 'text'
            },
            numberInputType:{
                type: String,
                default:'Number'
            },
            placeholder: String,   //  默认文本
            listen: Boolean,                //  用于应对一个组件有多个监听的情况下 区分是哪个选项卡的监听
            popupInput: {                   //  popup搜索框
                type: Boolean,
                default: false
            },
            Isdisabled:{
                type:Boolean,
                default:false
            },
            selectIndex: Number,           //  popup默认聚焦index
            manupopupInput:{                //供应商
               type:Boolean,
               default:true
            },name:String,                 //下拉组件   类型选择
            tabSelected:String | Number,
            // form:String,                  //子组件传递form值说明需要既下拉又输入
            ExistsTogether:{//父组件传递参数是否组合下拉内容
                type:Object,
                default:null
            },         //下拉是否拼接
            maxlength:String,//input模式下  输入框是否开启最大字符限制(undefind为不开启)
            SelectionAndInput:false,//是否开启既能选择又能输入(默认不开启，true>开启)
            },
        data() {
            return {
                //  是否显示弹窗
                showDiaLog: false,
                //  弹窗记录选择项
                renderData: this.type === 'popup' ? this.data[0] : null,
                //  用于弹窗或日期选择器 需要更改显示文本的场景
                showText: !!this.text ? String.trim(this.text) : this.placeholder,
                manuselectIndex:0,//()自定义)弹出框列表默认选中
                manudata:[],//（自定义）弹出框列表
                manudataArray:[],//（自定义）弹出框列表原始数据集合
                outTime:0,//定义延迟加载
                tabSelectIndex:'0',
                InputValues:null,//弹出框得输入框
                NumberInputValue:this.text,//数字输入框绑定值
                MaintainSelectIndex:'',//级联条件（维修 故障类型=》故障问题=》解决方案）
                MaintainSelectType:'',
            }
        },
        mounted() {
            this.$Bus.$on('RepairSelect', res => { //子组件接收数据
            this.MaintainSelectIndex=res.MaintainSelectIndex;
            this.MaintainSelectType=res.MaintainSelectType;
            })
        },
        methods: {
            //  公用点击
            menuClick() {
                if(this.name&&this.type!=="Number")this.unitl(this.name);
              this.showDiaLog = true;
            },
            //  弹窗滚动
            onChange(picker, value) {
                this.$emit('change', value);
                this.renderData = value
            },
            //  弹窗提交
            confirm() {
                if(!!this.renderData){
                    this.showText = this.renderData;
                }else{
                 this.showText = this.data[0];
                }
                this.showDiaLog = false;
                 this.$emit('confirm', this.renderData);
            },
            //  输入框
            input() {
                this.$emit('onMessage', event.target.value)
            },
            NumberInput(obj){//数字输入框
            // this.NumberInputValue=obj;//赋值给绑定变量
            this.$emit('onMessage', obj);
            },
            //  popup输入框
            _popupInput() {
                this.$emit('input', event.target.value)
            },
            //  日历
            onConfirm(date) {
                const _Date = `${date.getFullYear()}-${date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}`
                this.showDiaLog = false
                this.showText = _Date
                this.$emit('onMessage', _Date)
            },cancelValue(){//日历(以及其他组件删除选中得)删除
                this.renderData=null;
                this.showText = this.placeholder;
                this.$emit(this.type=='calendar'?'onMessage':'manuconfirm', this.type=='calendar'?null:{a:null,b:null,c:null,d:null,e:null,f:null});
            },DropDown(item){//自定义下拉
                this.showDiaLog=false;
                this.showText=item.name;
                this.renderData=item.name;
                this.$emit('manuconfirm', item);
            },
            //  tab
            tabChange(item, index) {
                this.tabSelectIndex = item.id;
                this.$emit('onMessage', item);
            },_manupopupInput(){//（自定义）输入框输入事件
            let inputValue=event.target.value;
            if (this.outTime == 0) {
                this.outTime = setTimeout(() => {
                    this.manuselectIndex=0;
                    this.unitl(this.name,inputValue);
                }, 800)
            } else {
                clearTimeout(this.outTime)
                this.outTime = setTimeout(() => {
                    this.manuselectIndex=0;
                    this.unitl(this.name,inputValue);
                }, 800)
            }
            this.renderData=null;
            }
            ,manuInputValue(event){//既需要下拉也需要输入的输入事件
                this.$emit('input', event.target.value)
            }
            ,manuconfirm(){//(自定义)列表选择事件
                // debugger
                this.showText=this.manudataArray[this.manuselectIndex].b;
                this.$emit('manuconfirm',this.manudataArray[this.manuselectIndex]);
                this.showDiaLog = false;
            },
            manuonChange(picker, value){//自定义列表下拉滑动事件
                 this.renderData = value;
                 this.manuselectIndex=this.manudata.findIndex(x=>x===value);
            },
            manuCancel(){//自定义弹出框 取消操作
                this.InputValues=null;
                this.showDiaLog=false;
                this.manuselectIndex=0;
                // this.renderData=null;
                // this.showText="请选择";
                //this.$emit('manuconfirm',{});
            },
            unitl(type,inputValue){//加载共用方法
                let RequestType='$post';
                let Url='';
                let Parms={
                    PageSize:10,
                    PageIndex:1,
                    QueryStr:inputValue?inputValue:'',
                    GKHM:this.$UserInfo.UserId,
                    lx:'',//生产厂家   or  供应商
                    Store:this.$UserInfo.StoreCode
                };
                 if(type==="supplier"||type==="manufacturer"||type==='maintain'){
                     Url='api/DropDownList/ManufacturerList',Parms.lx=type==="manufacturer"?'1':type==="supplier"?'2':'4'; //1供应商 2生产厂家 3维修公司)
                 }else if(type==='EquipmentDictionaries'||type==='EquipmentDictionariesNoText'){//设备字典查询（携带输入框和不没有输入框）
                     Url='api/DropDownList/EquipmentList';
                 }else if(type==='departmentList'){
                     Url='api/DropDownList/DepartmentList';//科室下拉
                 }else if(type==='brand'){
                     Url='api/DropDownList/BrandList';//品牌下拉
                 }else if(type==='areas'){
                     Url='api/DropDownList/AreaList';//产地下拉
                 }else if(type==='countries'){
                     Url='api/DropDownList/CountryList';//国别下拉
                 }else if(type==='equipmentClasses'){
                     Url='api/DropDownList/EquipmentClassList';//资产科目分类
                 }else if(type==='financeclassify'){
                     Url='api/DropDownList/GetFinanceClassify';//财务科目分类
                     RequestType='$get';
                     Parms={
                         q:inputValue?inputValue:''
                     };
                 }else if(type==='equipmentTypeList'){
                     Url='api/DropDownList/EquipmentTypeList';//设备类型
                     Parms={
                       PageSize:10,
                       QueryStr:inputValue
                     };
                 }else if(type==='assetsList'){
                     Url='api/DropDownList/AssetsList';//设备下拉
                     Parms={
                       PageIndex:1,
                       PageSize:10,
                       GKHM:this.$UserInfo.UserId,
                       Store:this.$UserInfo.StoreCode,
                       QueryStr:inputValue
                     };
                 }else if(type==='procurementmethod'){
                     Url='api/DropDownList/ProcurementDropDownList';//采购方式
                 }else if(type==='thetenderform'){
                     Url='api/DropDownList/TheTenderDropDownList';//招标形式
                 }else if(type==='personnel'){
                     Url='api/DropDownList/PersonnelList';//人员下拉
                 }else if(type==='failureProblem'){
                     Url='api/DropDownList/GetRepair';//故障问题下拉
                     Parms={
                       Nmae:inputValue?inputValue:'',
                       LX:'2',
                       BH:this.MaintainSelectType==='GZLX'?this.MaintainSelectIndex:''
                     };
                     RequestType='$post';
                 }else if(type==='solution'){//解决方案下拉
                     Url='api/DropDownList/GetRepair',
                     RequestType='$post',
                     Parms={
                       Nmae:inputValue?inputValue:'',
                       LX:'3',
                       BH:this.MaintainSelectType==='GZWT'?this.MaintainSelectIndex:''
                     };
                 }
                 else if(type==='faultType'){//故障类型
                     Url='api/DropDownList/GetRepair',
                     RequestType='$post',
                     Parms={
                       Nmae:inputValue?inputValue:'',
                       LX:'1',
                     };
                 }else if(type==='personnel_maintain'){//维修工程师
                     Url='api/Dispatch/GetRepaitUsersByH5',
                     RequestType='$get';
                     Parms={
                       QueryText:inputValue?inputValue:'',
                       UserCode:this.$UserInfo.UserId,
                       PageIndex:1,
                       PageSize:10,
                       Token:'123445'
                     };
                 }else if(type==='DeviceClass'){//资产类别
                     Url='api/DropDownList/DeviceClass',
                     RequestType='$get';
                     Parms={
                       Token:'12138',
                       q:inputValue?inputValue:'',
                     };
                 }else if(type==='SourcesOfAssets'){//资产来源
                     Url='api/DropDownList/GetSourcesOfAssets',
                     RequestType='$get';
                     Parms={
                       Token:'12138',
                       q:inputValue?inputValue:'',
                     };
                 }else if(type==='assetstates'){//资产状态
                     this.loadData([{a:'0',b:'停用'},
                                    {a:'1',b:'在用'},
                                    {a:'2',b:'保养'},
                                    {a:'3',b:'维修'},
                                    {a:'4',b:'计量'},
                                    {a:'5',b:'退库'},
                                    {a:'6',b:'清理'},
                                    {a:'7',b:'闲置'},
                                    {a:'9',b:'报废申请中'},
                                    {a:'A',b:'安装/验收'},
                                    {a:'B',b:'调配申请中'},
                                    {a:'C',b:'在库'},
                                    {a:'D',b:'调出'},
                                    {a:'E',b:'盘点'},
                                    {a:'F',b:'报废'},
                                    {a:'G',b:'调配'},
                                    {a:'H',b:'合同'},
                                    {a:'J',b:'捐赠'},
                                    {a:'L',b:'论证'},
                                    {a:'M',b:'却失'},
                                    {a:'P',b:'计划'},
                                    {a:'Q',b:'外调申请中'},
                                    {a:'S',b:'报损'},
                                    {a:'W',b:'外售'},
                                    {a:'Z',b:'转科申请中'}
                                    ]);
                                    return false;
                 }else if(type==='classification'){

                 }else if(type==='BLSJ_BGLY'){//不良事件报告来源
                     this.loadData([{a:'1',b:'生产企业'},
                                    {a:'2',b:'经营企业'},
                                    {a:'3',b:'使用单位'}]);
                                    return false;
                 }else if(type==='BLSJ_BGRZY'){//不良事件报告人职业
                     this.loadData([{a:'1',b:'专业人员'},
                                    {a:'2',b:'非专业人员'},
                                    {a:'3',b:'患者'},
                                    {a:'4',b:'其他(请注明)'}]);
                                    return false;
                 }else if(type==='BLSJ_EventResult'){//不良事件伤害
                     this.loadData([{a:'1',b:'死亡'},
                                    {a:'2',b:'严重伤害'},
                                    {a:'3',b:'其他'}]);
                                    return false;
                 }else if(type==='BLSJ_SYCS'){//不良事件使用场所
                     this.loadData([{a:'1',b:'医疗机构'},
                                    {a:'2',b:'家庭'},
                                    {a:'3',b:'其他(请注明)'}]);
                                    return false;
                 }else if(type==='BLSJ_BGZT'){//不良事件报告状态
                     this.loadData([{a:'1',b:'已通知使用单位'},
                                    {a:'2',b:'已通知生产企业'},
                                    {a:'3',b:'已通知经营企业'},
                                    {a:'4',b:'已通知药监部门'}]);
                                    return false;
                 }else if(type==='BLSJ_YYFX'){//不良事件原因分析
                     this.loadData([{a:'1',b:'产品原因'},
                                    {a:'2',b:'操作原因'},
                                    {a:'3',b:'患者自身原因'},
                                    {a:'4',b:'无法确定'}]);
                                    return false;
                 }
                 this[RequestType](Url,Parms).then(result=>{
                     if(!result.Status)
                     {
                         this.$Toast("数据异常,请联系管理员");
                         return;
                     }
                     this.loadData(type==="supplier"||type==="manufacturer"||type==='maintain'?result.Manufacturers:type==="EquipmentDictionaries"?result.Equipments:type==='departmentList'
                     ?result.Departments:type==="brand"?result.Brands:type==='EquipmentDictionariesNoText'?result.Equipments:type==='areas'?result.Areas:
                     type==='countries'?result.Countries:type==='equipmentClasses'?result.EquipmentClasses:type==='equipmentTypeList'?result.EquimentTypeList:
                     type==='assetsList'?result.AssetsList:type==='procurementmethod'?result.ProcurementList:type==='thetenderform'?result.TheTenderList:
                     type==='personnel'?result.Personnels:type==='personnel_maintain'?result.AssignUserList:type==='financeclassify'?
                     result.AssetsList:type==='DeviceClass'?result.EquimentTypeList:type==='SourcesOfAssets'?result.SourcesOfAssetsList:type==='faultType'||type==='failureProblem'||type==='solution'?result.RepairList:'');
                 })
                 this.showDiaLog=true;
            },loadData(result){
                this.manudataArray=result;
                let manuModel=[]; //临时存储对象
                for(let i=0;i<result.length;i++){
                    manuModel.push(result[i].b + (this.ExistsTogether!=null?`<br/>(${this.ExistsTogether.Name}:${result[i][this.ExistsTogether.Id]||'暂无'})`:''));
                }
                this.manudata=manuModel;
            }
        },
        components: {
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Calendar.name]: Calendar,
            [NumberKeyboard.name]:NumberKeyboard,
            [Field.name]:Field,
            [ActionSheet.name]:ActionSheet
        },
       watch: {
           text(value) {
               if(this.type=='number'){
                   this.NumberInputValue=value;//解决数字输入框不能在组件创建时赋值
               }
               this.showText=value?value:this.placeholder;
           },
           showText(newVal,oldVal){
               // this.showText=String.trim(this.showText?this.showText:'');
               // 去掉前后空格
               let valFroTrim = JSON.parse(JSON.stringify(String.trim(newVal||'')))
               // 去掉最末尾处的小数点
               // let result = valFroTrim.replace(/\.+$/, '');
               // if(result&&result.length>15){
               //     this.showText=`${this.showText.substring(0,15)}...`;
               // }else{
               //      this.showText= valFroTrim
               // }
                this.showText= valFroTrim
           },
           showDiaLog(value){
               if(!value){
                   this.manuselectIndex=0;
               }
           }
       }
    }
</script>

<style scoped lang="scss">
    .Field-Box{
        border-bottom: 2px solid #F3F3F3;
        &>div{
            display: flex;
            align-items: center;
            font-size: 29px;
            height: 112px;
            color: $TEXT-DARK-COLOR;
            .title{
                font-size: 30px;
                color: $TEXT-DARK-COLOR;
            }
            &>span{
                &:first-child{
                    flex:1;
                    span{
                        color: #FF2947;
                        font-size: 44px;
                        position: absolute;
                        margin-left: 5px;
                    }
                }
                // &:nth-child(2) {
                //     color: $TEXT-DARK-COLOR;
                // }

            }
            .popup{
                display: flex;
                align-items: center;
                color: #858585;
                img{
                    width: 32px;
                    height: 30px;
                    margin-left: 8px;
                }
            }
            input{
                min-width: 215px;
                font-size: 29px;
                text-align: right;
                &::-webkit-input-placeholder{
                    color: #858585;
                }
            }
            .action{
                color: $TEXT-DARK-COLOR;
            }
            .tab{
                display: flex;
                justify-content: flex-end;
                div{
                    min-width: 60px;
                    height: 50px;
                    background: #F3F3F3;
                    border: 2px solid #E8E8E8;
                    border-radius: 8px;
                    padding: 0 12px;
                    margin-left: 12px;
                    text-align: center;
                    line-height: 50px;
                    font-size: 26px;
                    color: #858585;
                    &:first-child{
                        margin-left: 0;
                    }
                }
                .actionTab{
                    background: $THEME-COLOR;
                    color: #fff;
                    border-color: rgba(0,0,0,0);
                }
            }
        }
        &:last-child{
            border: none;
        }
        textarea{
            font-size: 3.867vw;
            width: 100%;
            border: 1px solid #F3F3F3;
            color: #666666;
            resize: none;
            &::-webkit-input-placeholder{
                color: #858585;
            }
        }
    }
    .NumberClass{
        max-width: 50%;
                ::-webkit-input-placeholder{//更改placeholder 颜色
                    color:#858585;
                }
                ::-moz-placeholder{   /* Mozilla Firefox 19+ */
                    color:#858585;
                }
                :-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
                    color:#858585;
                }
                :-ms-input-placeholder{  /* Internet Explorer 10-11 */
                    color:#858585;
                }
    }
    .WidthVW{
        width:55vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: right;
    }

    .WidthVWEmpty{
        width:55vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: right;
        color:#828080;
    }
    .van-cell{
        padding: 0 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/field/field.vue